import { HStack } from "@chakra-ui/react"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { usePaginatedOrders } from "../providers/hooks/useOrders"
import OrdersTableAdvanced from "../components/OrdersTableAdvanced"
import OrderCreate from "../components/OrderCreate"

const PAGE_SIZE = 10

function Orders() {
  const [searchParams] = useSearchParams()

  // Orders hook - don't skip initial fetch since orders is the default view
  const {
    orders,
    pagination: ordersPagination,
    loading: ordersLoading,
    error: ordersError,
    filters: ordersFilters,
    sort: ordersSort,
    filterOptions: ordersFilterOptions,
    fetchOrders,
    setFilters: setOrdersFilters,
    setSort: setOrdersSort,
    clearFilters: clearOrdersFilters,
    refetch: refetchOrders,
  } = usePaginatedOrders(PAGE_SIZE, false)

  useEffect(() => {
    // Check for query parameters
    const assetId = searchParams.get("asset")
    const customerId = searchParams.get("customer")
    const orderId = searchParams.get("order")

    const urlFilters: Record<string, string> = {}

    if (assetId) {
      urlFilters.asset = assetId
    }
    if (customerId) {
      urlFilters.customer = customerId
    }
    if (orderId) {
      urlFilters.name = orderId // Order ID filtering uses the 'name' field
    }

    if (Object.keys(urlFilters).length > 0) {
      // If any parameter exists, set filter and fetch
      setOrdersFilters(urlFilters)
      fetchOrders(1, PAGE_SIZE, urlFilters)
    } else {
      // Load first page on mount - only run once
      fetchOrders(1, PAGE_SIZE)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <OrdersTableAdvanced
      orders={orders}
      loading={ordersLoading}
      error={ordersError}
      onRetry={refetchOrders}
      filterOptions={ordersFilterOptions}
      headerActions={
        <HStack gap={2}>
          <OrderCreate />
        </HStack>
      }
      serverPagination={
        ordersPagination
          ? {
              pagination: ordersPagination,
              onPageChange: (page: number) => fetchOrders(page, ordersPagination.per_page, ordersFilters, ordersSort),
              onPageSizeChange: (pageSize: number) => fetchOrders(1, pageSize, ordersFilters, ordersSort),
            }
          : undefined
      }
      serverFiltering={{
        filters: ordersFilters,
        sort: ordersSort,
        onFiltersChange: setOrdersFilters,
        onSortChange: setOrdersSort,
        onClearAll: clearOrdersFilters,
      }}
    />
  )
}
export default Orders
